import React, { useState } from "react";
import { AcSidebar } from "../Components/AccountSettings/AcSidebar";
import { AccountSettingsComponent } from "../Components/AccountSettings/AccountSettingsComponent";
import { BillingDetails } from "../Components/AccountSettings/BillingDetails";
import { FavoriteProducts } from "../Components/AccountSettings/FavoriteProducts";
import { MyOrders } from "../Components/AccountSettings/MyOrders";
import { useParams } from "react-router-dom";

export const AccountSettings = () => {
  const {id} = useParams()
  const [showCurrentTab, setShowCurrentTab] = useState(id);
  const accountSettings = [
    { id: 4, currentPage: <AccountSettingsComponent /> },
    { id: 3, currentPage: <BillingDetails /> },
    { id: 2, currentPage: <FavoriteProducts /> },
    { id: 1, currentPage: <MyOrders /> },
  ];
  return (
    <div className="flex py-4 lg:py-0 px-4">
      <AcSidebar
        setShowCurrentTab={setShowCurrentTab}
        currentColor={"bg-[#1C1C1C]  text-white dark:bg-white dark:text-black"}
        currentTab={showCurrentTab}
      />
      {accountSettings.map((accountSetting) => {
        if (showCurrentTab == accountSetting.id) {
          return accountSetting.currentPage;
        }
      })}
    </div>
  );
};
